import axios, { AxiosInstance } from "axios";
import { spire360ApiClient } from "./Spire360ApiClient";

// call-summary endpoint lives on appointment-experience-api (keyed by appointmentId) -
// see CALL_SUMMARY_WEB_HANDOFF.md. appointment-experience-client (the generated swagger
// package) does not yet expose a method for this route - swagger-gen hasn't been re-run
// since the backend PR merged - so this helper hits it directly, mirroring the
// gateway/non-gateway auth pattern createAppointmentApi/getZoomHostStartUrl already use
// in AppointmentApiHelper.ts.
//
// Swap-over path once a generated method exists: rewrite only getCallSummary's body below
// to delegate to createAppointmentApi() (or a dedicated generated client). The
// CallSummaryApi interface and every call site (useZoomCallSummary) stay unchanged.

// Static service userid used for non-gateway auth, matching AppointmentApiHelper.ts.
const SERVICE_USER_ID = "afcb9359-d4d4-4ed7-9e1c-c5b326ff1b66";

const GET_CALL_SUMMARY_TIMEOUT_MS = 10000;

export type CallSummaryStatus = "pending" | "processing" | "completed" | "failed";

export interface CallSummaryTaskDto {
  task: string;
  owner: string;
  context: string;
}

export interface CallSummaryDto {
  status: CallSummaryStatus;
  executiveSummary: string | null;
  detailedSummary: string | null;
  suggestedTasks: CallSummaryTaskDto[] | null;
  modelId: string | null;
  promptVersion: string | null;
  tokenUsage: object | null;
  latencyMs: number | null;
  errorMessage: string | null;
  generatedAt: string | null;
}

export interface CallSummaryApi {
  getCallSummary(appointmentId: string): Promise<{ data: CallSummaryDto | null; status: number }>;
}

function getBasePath(): string {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  return isGatewayEnabled
    ? `${process.env.REACT_APP_APPOINTMENT_API_URL_GATEWAY}`
    : `${process.env.REACT_APP_APPOINTMENT_API_URL}`;
}

export function createCallSummaryApi(): CallSummaryApi {
  return {
    getCallSummary: async (appointmentId: string) => {
      const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
      const path = `${getBasePath()}/appointment/${appointmentId}/call-summary`;
      const client: AxiosInstance = isGatewayEnabled ? spire360ApiClient : axios;
      const response = await client.get(path, {
        timeout: GET_CALL_SUMMARY_TIMEOUT_MS,
        headers: isGatewayEnabled ? undefined : { userid: SERVICE_USER_ID },
      });
      // "No summary yet" comes back as a 200 with an empty body - a NestJS quirk (returning
      // null from a controller serializes to an empty response, not the string "null").
      // An empty body can surface here as "" (empty string) rather than null/undefined, so
      // ?? won't reliably normalize it - use an explicit falsy check instead.
      return { data: response.data ? response.data : null, status: response.status };
    },
  };
}
